<template>
    <div>
        <span v-show="enabled">
            <input type="text"  autocomplete="off" class="layui-input layuidatetime" readonly="readonly"/>
            <i class="layui-icon layui-icon-date" style="position: absolute;top:calc(50% - 8px);;right: 8px;margin-top: 0px;"></i>
        </span>
        <span v-show="!enabled">
            <input type="text"  autocomplete="off" class="layui-input layui-disabled layuidatetime-disabled" readonly="readonly" disabled="disabled"/>
            <i class="layui-icon layui-icon-date" style="position: absolute;top:calc(50% - 8px);;right: 8px;margin-top: 0px;"></i>
        </span>
    </div>
</template>

<script>
export default {
     name: 'LayuiDatetime',
     _model: {
        default: '',
        required: false
    },
    props: {
        placeholder: {
            default: '',
            type: String
        },
        _model: {
            default: '',
            required: false
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        //显示当前时间
        showNewDate:{
            type: Boolean,
            default: ()=>{
                return false;
            }
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
     data: function(){
        return {
        }
     },
     mounted(){
        var id = this.id = 'layuidatetime' + this.uuid();
        var element = this.el = $(this.$el);
        if(this.placeholder) {
            element.find('.layuidatetime').attr('placeholder', this.placeholder);
        }
        element.find('.layuidatetime').attr('id', this.id);
        this.layui.laydate.render({
            elem: '#' + this.id,
            type: 'datetime',
            value: this.showNewDate ? new Date() : '',
            trigger: 'click',//呼出事件改成click(处理小屏幕弹不出的问题)
            done: (value, date) => {
                this.$emit('_modelEvent', value);
                this.$emit('dateChange', value);
            }
        });
        //赋值当前时间
        if(this.showNewDate){
            var value = this.systemDate();
            this.$emit('_modelEvent', value);
            // this.$emit('dateChange', value);
        }
    },
    methods: {
        select(value) {
            this.el.find('.layuidatetime,.layuidatetime-disabled').val(value);
        },
        //系统消息
        systemDate(){
            var thisDate = new Date();
            return thisDate.getFullYear() + "-" + (thisDate.getMonth() + 1) + "-" + thisDate.getDate() + " "+ thisDate.getHours() + ":" + thisDate.getMinutes() + ":" + thisDate.getSeconds();
        }
    },
    watch:{
        _model(value){
           this.select(value);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiDatetime.vue